//  add prescreening question
export const SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK = "SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK"
export const SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS = "SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS"
export const SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL = "SEARCH_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL"

//  add prescreening question
export const ADD_PRESCREENING_QUESTION = "ADD_PRESCREENING_QUESTION"
export const ADD_PRESCREENING_QUESTION_SUCCESS = "ADD_PRESCREENING_QUESTION_SUCCESS"
export const ADD_PRESCREENING_QUESTION_FAIL = "ADD_PRESCREENING_QUESTION_FAIL"

//update prescreening question
export const UPDATE_PRESCREENING_QUESTION = "UPDATE_PRESCREENING_QUESTION"
export const UPDATE_PRESCREENING_QUESTION_SUCCESS = "UPDATE_PRESCREENING_QUESTION_SUCCESS"
export const UPDATE_PRESCREENING_QUESTION_FAIL = "UPDATE_PRESCREENING_QUESTION_FAIL"

export const GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK = "GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK"
export const GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS = "GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_SUCCESS"
export const GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL = "GET_SELECTED_PRESCREENING_QUESTION_FROM_QUESTION_BANK_FAIL"

